import { createReducer } from '../../../store.model';

import {
    ActionType,
    GridReset,
    Reload,
    SortPerformanceGrid,
} from './grid.action';
import { sortPerformanceGrid, syncPerformanceGrid } from './grid.function';
import { defaultGridState, GridState } from './grid.state';

const { reducer, builder } = createReducer<ActionType, GridState>(
    defaultGridState(),
);

builder.add<Reload>(ActionType.SCORECARD_GRID__RELOAD, (state, action) => {
    const nextPerformerGrid = syncPerformanceGrid(
        action.payload.tplConfig,
        action.payload.options.columnNameOverrides,
        action.payload.header,
        action.payload.data,
        state.performanceGrid.sortDefs,
    );

    return {
        ...state,
        mode: action.payload.tplConfig.mode,
        performanceGrid: nextPerformerGrid,
        prevPerformanceGrid: nextPerformerGrid,
        attributes: action.payload.attributes,
        messages: action.payload.tplConfig.messages,
        tplConfig: action.payload.tplConfig,
    };
});

builder.add<SortPerformanceGrid>(
    ActionType.SCORECARD_GRID__PERFORMANCE__SORT,
    (state, action) => {
        const { rows: nextRows, sortDefs: nextSortDefs } = sortPerformanceGrid(
            action.payload.columnId,
            state.performanceGrid.columns,
            state.performanceGrid.rows,
            state.performanceGrid.sortDefs,
        );

        return {
            ...state,
            performanceGrid: {
                ...state.performanceGrid,
                rows: nextRows,
                sortDefs: nextSortDefs,
            },
        };
    },
);

builder.add<GridReset>(ActionType.SCORECARD_GRID__RESET, (state, action) => {
    return {
        ...state,
        performanceGrid: state.prevPerformanceGrid,
    };
});

export default {
    grid: reducer,
};
